// SmsOptInPage — public SMS opt-in page at /sms.
//
// This is one of the three assets The Campaign Registry (10DLC carrier review)
// fetches to verify consent is real: it must show the brand, the six mandatory
// disclosures, "not a condition of purchase", and working Terms + Privacy links —
// all at the point of capture. The <SmsOptIn> block renders those inline.
//
// Form shape (carrier rule, 4th iteration 2026-07-06): email is the required
// anchor field; the mobile number and BOTH consent checkboxes are explicitly
// optional, and the form completes successfully in every combination. See the
// design contract in components/SmsOptIn.tsx.

import TakerShell from './components/TakerShell';
import { SmsOptIn } from './components/SmsOptIn';

export default function SmsOptInPage() {
  return (
    <TakerShell footerLabel="The Successful Bookkeeper">
      <div style={{ maxWidth: 620, margin: '0 auto', padding: '48px 20px 80px' }}>
        <h1 style={{ fontFamily: "'Fraunces', serif", fontSize: 38, fontWeight: 900, color: '#0A0A2E', lineHeight: 1.1, margin: '0 0 12px' }}>
          Get text reminders from The Successful Bookkeeper
        </h1>
        <p style={{ fontSize: 17, color: '#44445e', lineHeight: 1.55, margin: '0 0 28px' }}>
          Never miss a session, a live call, or a deadline. Leave your email below — then,
          only if you'd like texts from us, add your mobile number and tick the kinds you
          want. The mobile number and both checkboxes are entirely optional. You're always
          in control — reply STOP any time to cancel.
        </p>

        <div style={{ background: '#fff', borderRadius: 16, padding: '24px 24px 28px', boxShadow: '0 4px 24px rgba(10,10,46,0.06)' }}>
          {/* Standalone mode: required email anchor, optional mobile-number field,
              both optional consent checkboxes with full disclosures, and the
              submit button all render up front — this is the page The Campaign
              Registry fetches to verify the opt-in is real. */}
          <SmsOptIn
            source="sms-optin-page"
            heading="Get text reminders"
            standalone
          />
        </div>
      </div>
    </TakerShell>
  );
}
